module.exports = __webpack_public_path__ + "img/launch_thumbnail-600x450.bc2385fb.jpg";